module.exports = __webpack_public_path__ + "static/media/bottles_edited.9a24683a.png";